import { z } from 'zod'

// ── Display Name ──────────────────────────────────────────────

export const updateDisplayNameSchema = z.object({
  displayName: z
    .string()
    .min(2, 'El nombre debe tener al menos 2 caracteres')
    .max(80, 'El nombre no puede exceder 80 caracteres')
    .regex(/^[\p{L}\p{N}\s\-'.]+$/u, 'Caracteres no permitidos en el nombre'),
})

export type UpdateDisplayNameInput = z.infer<typeof updateDisplayNameSchema>

// ── Cambio de Contraseña (self-service) ───────────────────────

export const changePasswordSchema = z
  .object({
    currentPassword: z.string().min(1, 'Contraseña actual requerida'),
    newPassword: z
      .string()
      .min(8, 'La nueva contraseña debe tener al menos 8 caracteres')
      .regex(/[A-Z]/, 'Debe contener al menos una letra mayúscula')
      .regex(/[a-z]/, 'Debe contener al menos una letra minúscula')
      .regex(/[0-9]/, 'Debe contener al menos un número')
      .regex(/[^A-Za-z0-9]/, 'Debe contener al menos un carácter especial'),
    confirmPassword: z.string(),
  })
  .refine((d) => d.newPassword === d.confirmPassword, {
    message: 'Las contraseñas no coinciden',
    path: ['confirmPassword'],
  })
  .refine((d) => d.currentPassword !== d.newPassword, {
    message: 'La nueva contraseña debe ser diferente a la actual',
    path: ['newPassword'],
  })

export type ChangePasswordInput = z.infer<typeof changePasswordSchema>

// ── Admin Reset de Contraseña ─────────────────────────────────

export const adminResetPasswordSchema = z.object({
  newPassword: z
    .string()
    .min(8, 'Mínimo 8 caracteres')
    .regex(/[A-Z]/, 'Debe contener al menos una mayúscula')
    .regex(/[a-z]/, 'Debe contener al menos una minúscula')
    .regex(/[0-9]/, 'Debe contener al menos un número'),
  notifyUser: z.boolean().default(true),
})

export type AdminResetPasswordInput = z.infer<typeof adminResetPasswordSchema>

// ── Verificação de ação admin (re-autenticação) ───────────────

export const verifyAdminActionSchema = z.object({
  password: z.string().min(1, 'Contraseña requerida'),
  action: z.string().min(1, 'Acción requerida'),
})

export type VerifyAdminActionInput = z.infer<typeof verifyAdminActionSchema>
